import { defineStore } from "pinia"
import { format, addDays } from "date-fns"
import { fetchApiJson, postApiJson } from "@/services/repowerAPIService.js"

export const EXPORT_TYPES = {
  RECORDS: "records",
  RECORD_STREAMS: "record_streams",
  MEASUREMENTS: "measurements",
}

export default defineStore("repower/exportsStore", {
  state: () => ({
    exports: [],
    loading: false,
    loadingFailed: false,
  }),
  actions: {
    async loadExports() {
      this.loading = true
      this.loadingFailed = false

      try {
        const data = await fetchApiJson("/exports/")
        this.exports = Array.isArray(data) ? data : []
        return this.exports
      } catch (error) {
        this.exports = []
        this.loadingFailed = true
        throw error
      } finally {
        this.loading = false
      }
    },

    async requestExport(
      meteringPointId,
      exportType,
      dateRange,
      frequency,
      measurementTypes,
      onSuccess,
      onFail,
    ) {
      if (!Object.values(EXPORT_TYPES).includes(exportType)) {
        throw new Error(`Unsupported export type: ${exportType}`)
      }

      const payload = {
        metering_point_id: meteringPointId,
        export_type: exportType,
        date_start: format(dateRange[0], "yyyy-MM-dd"),
        date_end: format(addDays(dateRange[1], 1), "yyyy-MM-dd"),
        frequency,
      }

      if (exportType === EXPORT_TYPES.MEASUREMENTS) {
        payload.measurement_types = measurementTypes
      }

      try {
        const data = await postApiJson("/exports/", payload)
        onSuccess?.(data)
      } catch (error) {
        onFail?.(error)
      }
    },

    async getExportDownload(exportId) {
      return fetchApiJson(`/exports/${exportId}/download/`)
    },
  },
})
